import { EventEmitter } from '@angular/core';
import { ProjectAssetMappingService } from '@app/cem/project/content/project-asset-mapping/project-asset-mapping.service';
import { SelectedTabService } from '@app/cem/project/services/selected-tab.service';
import { ProjectAssetMappingCostCenterService } from 'app/cem/project/services/project-asset-mapping-cost-center.service';
import { IProjectTab } from 'app/shared/interfaces/iproject-tab';
import { Project } from 'app/shared/models';

export class ProjectTab implements IProjectTab {

  private _Project: Project;
  private _ProjectTypeDesc: string;

  get ProjectId(): number {
    return this.Project.ProjectId;
  }
  set ProjectId(id: number) {
    this.Project.ProjectId = id;
  }

  get AfeNumber(): string {
    return this.Project.AfeNumber;
  }
  set AfeNumber(afeNumber: string) {
    this.Project.AfeNumber = afeNumber;
  }

  get Name(): string {
    return this.Project.Name;
  }
  set Name(value: string) {
    this.Project.Name = value;
  }

  get ProjectTypeId(): number {
    return this.Project.ProjectTypeId;
  }
  set ProjectTypeId(id: number) {
    this.Project.ProjectTypeId = id;
  }

  get ProjectSubTypeId(): number {
    return this.Project.ProjectSubTypeId;
  }
  set ProjectSubTypeId(id: number) {
    this.Project.ProjectSubTypeId = id;
  }

  get ProjectType(): string {
    return (this._Project.ProjectType && this.Project.ProjectType.Description) ||
      this._ProjectTypeDesc;
  }
  set ProjectType(value: string) {
    this._ProjectTypeDesc = value;
  }

  get DefaultProjectTeamId(): number {
    return this.Project.DefaultProjectTeamId;
  }
  set DefaultProjectTeamId(id: number) {
    this.Project.DefaultProjectTeamId = id;
  }

  get AssetTeamId(): number {
    return this.Project.AssetTeamId;
  }
  set AssetTeamId(id: number) {
    this.Project.AssetTeamId = id;
  }

  get FunctionId(): number {
    return this.Project.FunctionId;
  }
  set FunctionId(id: number) {
    this.Project.FunctionId = id;
  }

  get ScenarioId(): number {
    return this.Project.ScenarioId;
  }
  set ScenarioId(id: number) {
    this.Project.ScenarioId = id;
  }

  get IsProjectTeamSync(): boolean {
    return this.Project.IsProjectTeamSync;
  }
  set IsProjectTeamSync(value: boolean) {
    this.Project.IsProjectTeamSync = value;
  }

  get ProjectStatusId(): number {
    return this.Project.ProjectStatusId;
  }
  set ProjectStatusId(id: number) {
    this.Project.ProjectStatusId = id;
  }

  Disabled?: boolean;
  IsSelected?: boolean;

  ProjectAssetMappingCostCenterService?: ProjectAssetMappingCostCenterService;
  ProjectAssetMappingService?: ProjectAssetMappingService;
  SelectedTabService?: SelectedTabService;

  get Project(): Project {
    return this._Project;
  }
  set Project(value: Project) {
    if (!this._Project) {
      this._Project = value;
    } else {
      Object.assign(this._Project, value);
    }
  }
  ProjectChanged: EventEmitter<Project> = new EventEmitter();

  constructor(source?: IProjectTab) {
    if (source && source.Project) {
      this._Project = source.Project;
      delete source.Project;
    } else {
      this._Project = new Project();
    }
    if (source) {
      Object.assign(this, source);
      if (!this.ProjectChanged) {
        this.ProjectChanged = new EventEmitter();
      }
    }
  }
}